import type { HubJobCreator } from '@robovision/hub'


export interface JobCreatorParams {
  id: string
  name: string
}

export class JobCreator {
  public readonly id: string
  public readonly name: string

  public constructor (params: JobCreatorParams) {
    this.id = params.id
    this.name = params.name
  }

  public static fromResponse (response: HubJobCreator): JobCreator {
    return new JobCreator({
      id: response.id,
      name: response.name,
    })
  }
}
